import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-telegram",
  "use": "icon-telegram-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 32 32\" id=\"icon-telegram\"><circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#08C\" /><path fill=\"#fff\" d=\"M23.985 9.381c.142-.92-.733-1.647-1.552-1.287L6.131 15.25c-.587.258-.544 1.147.065 1.34l3.362 1.072a2.167 2.167 0 0 0 1.897-.289l7.58-5.236c.228-.159.477.167.282.368L13.86 18.13c-.53.546-.424 1.47.212 1.87l6.109 3.83c.685.43 1.566-.002 1.694-.83l2.109-13.62Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol